import { html, LitElement, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { PageNavigationHeaderItem } from '../types';
import { FontSizes, FontWeights } from 'apps/webcomponents/src/types/common/types';

@customElement('gz-page-navigation-header')
export class GzPageNavigationHeaderWebComponent extends LitElement {
  @property({ type: Array, attribute: true, reflect: true })
  items: Array<PageNavigationHeaderItem>;

  static get styles() {
    return styles;
  }

  render() {
    return html`<div class="header">${this.renderHeader()}</div>`;
  }

  private renderHeader(): TemplateResult[] | undefined {
    if (!this.items || !this.items.length) {
      return;
    }

    const header: TemplateResult[] = [];
    for (let i = 0; i < this.items.length; i++) {
      header.push(
        html`<span
          class="section ellipsis-middle"
          isClickable="${!!this.items[i].onClickFunction}"
          fontWeight="${this.items[i].fontWeight || FontWeights.NORMAL}"
          fontSize="${this.items[i].fontSize || FontSizes.HEADING_6}"
          @click="${this.items[i].onClickFunction}"
          >${this.items[i].text}</span
        >`
      );
    }

    return header;
  }
}
